import { Directive, OnInit, OnDestroy, Optional, Host } from '@angular/core';
import { FormGroupDirective, AbstractControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';

@Directive({
  selector: '[validateOnTouch]'
})
export class ValidateOnTouchDirective implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    @Optional() @Host() private formGroupDir: FormGroupDirective
  ) { }

  ngOnInit() {
    if (this.formGroupDir && this.formGroupDir.form) {
      this.patchMarkAllAsTouched();
      this.patchIndividualControls();
    }
  }

  private patchMarkAllAsTouched() {
    const originalMarkAllAsTouched = this.formGroupDir.form.markAllAsTouched;

    const newMarkAllAsTouched = (opts?: { onlySelf?: boolean }) => {
      (originalMarkAllAsTouched as (opts?: { onlySelf?: boolean }) => void).call(this.formGroupDir.form, opts);
      this.checkControlsValidation();
    };

    Object.defineProperty(this.formGroupDir.form, 'markAllAsTouched', {
      value: newMarkAllAsTouched,
      writable: true,
      configurable: true
    });
  }

  private patchIndividualControls() {
    const controls = this.formGroupDir.form.controls;

    Object.keys(controls).forEach(key => {
      const control = controls[key];
      if (control) {
        this.overrideMarkAsTouched(control, key); // Pass the key to the override function
      }
    });
  }

  private overrideMarkAsTouched(control: AbstractControl, key: string) {
    const originalMarkAsTouched = control.markAsTouched;

    control.markAsTouched = (opts?: { onlySelf?: boolean }) => {
      (originalMarkAsTouched as (opts?: { onlySelf?: boolean }) => void).call(control, opts);
      this.validateControl(control, key); // Pass the key for validation
    };
  }

  private checkControlsValidation() {
    if (!this.formGroupDir?.form) return;

    Object.keys(this.formGroupDir.form.controls).forEach(key => {
      const control = this.formGroupDir.form.get(key);
      if (control) {
        this.validateControl(control, key); // Pass the key for validation
      }
    });
  }

  private validateControl(control: AbstractControl, key: string) {
    // Clear previous errors
   
    
    //-------------------------------------------for Advisor Accountant form------------------------------------------------------------------------------------------------//
    if (key === 'accountant_Details_Address_Line_1') {
      control.setErrors(null);
      const name = control.parent?.get('accountant_Details_Name');
      const Postcode = control.parent?.get('accountant_Details_postcode');
      const adress1 = control.parent?.get('accountant_Details_Address_Line_1');
      const adress2 = control.parent?.get('accountant_Details_Address_Line_2');
      const adress3 = control.parent?.get('accountant_Details_Address_Line_3');
      const city = control.parent?.get('accountant_Details_city');
      debugger
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
         // Postcode?.setErrors({ required: true });
        }

      }
      else {
        if (Postcode?.value || adress2?.value || adress3?.value|| city?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value &&  !city?.value) {
         
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        
      }
    }
    if (key === 'accountant_Details_Address_Line_2') {
      control.setErrors(null);
      const name = control.parent?.get('accountant_Details_Name');
      const Postcode = control.parent?.get('accountant_Details_postcode');
      const adress1 = control.parent?.get('accountant_Details_Address_Line_1');
      const adress2 = control.parent?.get('accountant_Details_Address_Line_2');
      const adress3 = control.parent?.get('accountant_Details_Address_Line_3');
      const city = control.parent?.get('accountant_Details_city');
      if (adress2?.value) {
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
      }
      else {
        if (  adress3?.value) {
          adress2?.setErrors({ required: true });
        }
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {
         
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'accountant_Details_Address_Line_3') {
      control.setErrors(null);
      const name = control.parent?.get('accountant_Details_Name');
      const Postcode = control.parent?.get('accountant_Details_postcode');
      const adress1 = control.parent?.get('accountant_Details_Address_Line_1');
      const adress2 = control.parent?.get('accountant_Details_Address_Line_2');
      const adress3 = control.parent?.get('accountant_Details_Address_Line_3');
      const city = control.parent?.get('accountant_Details_city');
      if (adress3?.value) {
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!adress2?.value) {
          adress2?.setErrors({ required: true });
        }
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value &&  !adress2?.value && !adress3?.value&& !city?.value) {

          Postcode?.setErrors(null)
          //adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'accountant_Details_Name') {
      control.setErrors(null);
      const name = control.parent?.get('accountant_Details_Name');
      const Postcode = control.parent?.get('accountant_Details_postcode');
      const adress1 = control.parent?.get('accountant_Details_Address_Line_1');
      const adress2 = control.parent?.get('accountant_Details_Address_Line_2');
      const adress3 = control.parent?.get('accountant_Details_Address_Line_3');
      const city = control.parent?.get('accountant_Details_city');
      if (!control.value) {
        if (name?.value || Postcode?.value || adress1?.value || adress2?.value || city?.value) {
          control?.setErrors({ required: true })
        }
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'accountant_Details_city') {
      control.setErrors(null);
      const name = control.parent?.get('accountant_Details_Name');
      const Postcode = control.parent?.get('accountant_Details_postcode');
      const adress1 = control.parent?.get('accountant_Details_Address_Line_1');
      const adress2 = control.parent?.get('accountant_Details_Address_Line_2');
      const adress3 = control.parent?.get('accountant_Details_Address_Line_3');
      const city = control.parent?.get('accountant_Details_city');
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
         // Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value  && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'accountant_Details_county') {
      control.setErrors(null);
      const name = control.parent?.get('accountant_Details_Name');
      const Postcode = control.parent?.get('accountant_Details_postcode');
      const adress1 = control.parent?.get('accountant_Details_Address_Line_1');
      const adress2 = control.parent?.get('accountant_Details_Address_Line_2');
      const adress3 = control.parent?.get('accountant_Details_Address_Line_3');
      const city = control.parent?.get('accountant_Details_city');
      const county = control.parent?.get('accountant_Details_county');
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
          // Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'accountant_Details_country') {
      control.setErrors(null);
      const name = control.parent?.get('accountant_Details_Name');
      const Postcode = control.parent?.get('accountant_Details_postcode');
      const adress1 = control.parent?.get('accountant_Details_Address_Line_1');
      const adress2 = control.parent?.get('accountant_Details_Address_Line_2');
      const adress3 = control.parent?.get('accountant_Details_Address_Line_3');
      const city = control.parent?.get('accountant_Details_city');
      const county = control.parent?.get('accountant_Details_county');
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
          // Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'accountant_Details_postcode') {
      control.setErrors(null);
      const name = control.parent?.get('accountant_Details_Name');
      const Postcode = control.parent?.get('accountant_Details_postcode');
      const adress1 = control.parent?.get('accountant_Details_Address_Line_1');
      const adress2 = control.parent?.get('accountant_Details_Address_Line_2');
      const adress3 = control.parent?.get('accountant_Details_Address_Line_3');
      const city = control.parent?.get('accountant_Details_city');
      const country = control.parent?.get('accountant_Details_country');
      if (!control.value) {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
         
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (country?.value) {
          if (Postcode?.value) {
            
          }
          else {
            Postcode?.setErrors({ required: true });
          }
        }
      }
      else {
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
      }
    }
    //-------------------------------------------for Advisor Bankers form------------------------------------------------------------------------------------------------//
    if (key === 'banker_Details_Address_Line_1') {
      control.setErrors(null);
      const name = control.parent?.get('banker_Details_Name');
      const Postcode = control.parent?.get('banker_Details_postcode');
      const adress1 = control.parent?.get('banker_Details_Address_Line_1');
      const adress2 = control.parent?.get('banker_Details_Address_Line_2');
      const adress3 = control.parent?.get('banker_Details_Address_Line_3');
      const city = control.parent?.get('banker_Details_city');
      debugger
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
         // Postcode?.setErrors({ required: true });
        }

      }
      else {
        if (Postcode?.value || adress2?.value || adress3?.value || city?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {

          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }

      }
    }
    if (key === 'banker_Details_Address_Line_2') {
      control.setErrors(null);
      const name = control.parent?.get('banker_Details_Name');
      const Postcode = control.parent?.get('banker_Details_postcode');
      const adress1 = control.parent?.get('banker_Details_Address_Line_1');
      const adress2 = control.parent?.get('banker_Details_Address_Line_2');
      const adress3 = control.parent?.get('banker_Details_Address_Line_3');
      const city = control.parent?.get('banker_Details_city');
      if (adress2?.value) {
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
      }
      else {
        if ( adress3?.value) {
          adress2?.setErrors({ required: true });
        }
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {

          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'banker_Details_Address_Line_3') {
      control.setErrors(null);
      const name = control.parent?.get('banker_Details_Name');
      const Postcode = control.parent?.get('banker_Details_postcode');
      const adress1 = control.parent?.get('banker_Details_Address_Line_1');
      const adress2 = control.parent?.get('banker_Details_Address_Line_2');
      const adress3 = control.parent?.get('banker_Details_Address_Line_3');
      const city = control.parent?.get('banker_Details_city');
      if (adress3?.value) {
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!adress2?.value) {
          adress2?.setErrors({ required: true });
        }
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress2?.value && !adress3?.value && !city?.value) {

          Postcode?.setErrors(null)
          //adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'banker_Details_Name') {
      control.setErrors(null);
      const name = control.parent?.get('banker_Details_Name');
      const Postcode = control.parent?.get('banker_Details_postcode');
      const adress1 = control.parent?.get('banker_Details_Address_Line_1');
      const adress2 = control.parent?.get('banker_Details_Address_Line_2');
      const adress3 = control.parent?.get('banker_Details_Address_Line_3');
      const city = control.parent?.get('banker_Details_city');
      if (!control.value) {
        if (name?.value || Postcode?.value || adress1?.value || adress2?.value || city?.value) {
          control?.setErrors({ required: true })
        }
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'banker_Details_city') {
      control.setErrors(null);
      const name = control.parent?.get('banker_Details_Name');
      const Postcode = control.parent?.get('banker_Details_postcode');
      const adress1 = control.parent?.get('banker_Details_Address_Line_1');
      const adress2 = control.parent?.get('banker_Details_Address_Line_2');
      const adress3 = control.parent?.get('banker_Details_Address_Line_3');
      const city = control.parent?.get('banker_Details_city');
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
         // Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'banker_Details_county') {
      control.setErrors(null);
      const name = control.parent?.get('banker_Details_Name');
      const Postcode = control.parent?.get('banker_Details_postcode');
      const adress1 = control.parent?.get('banker_Details_Address_Line_1');
      const adress2 = control.parent?.get('banker_Details_Address_Line_2');
      const adress3 = control.parent?.get('banker_Details_Address_Line_3');
      const city = control.parent?.get('banker_Details_city');
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
          // Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'banker_Details_country') {
      control.setErrors(null);
      const name = control.parent?.get('banker_Details_Name');
      const Postcode = control.parent?.get('banker_Details_postcode');
      const adress1 = control.parent?.get('banker_Details_Address_Line_1');
      const adress2 = control.parent?.get('banker_Details_Address_Line_2');
      const adress3 = control.parent?.get('banker_Details_Address_Line_3');
      const city = control.parent?.get('banker_Details_city');
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
          // Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'banker_Details_postcode') {
      control.setErrors(null);
      const name = control.parent?.get('banker_Details_Name');
      const Postcode = control.parent?.get('banker_Details_postcode');
      const adress1 = control.parent?.get('banker_Details_Address_Line_1');
      const adress2 = control.parent?.get('banker_Details_Address_Line_2');
      const adress3 = control.parent?.get('banker_Details_Address_Line_3');
      const city = control.parent?.get('banker_Details_city');
      if (!control.value) {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {

          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (adress1?.value || adress2?.value || city?.value) {
        //  Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
      }
    }
    //-------------------------------------------for Advisor solicitor form------------------------------------------------------------------------------------------------//
    if (key === 'solicitor_Details_Address_Line_1') {
      control.setErrors(null);
      const name = control.parent?.get('solicitor_Details_Name');
      const Postcode = control.parent?.get('solicitor_Details_postcode');
      const adress1 = control.parent?.get('solicitor_Details_Address_Line_1');
      const adress2 = control.parent?.get('solicitor_Details_Address_Line_2');
      const adress3 = control.parent?.get('solicitor_Details_Address_Line_3');
      const city = control.parent?.get('solicitor_Details_city');
      debugger
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
        //  Postcode?.setErrors({ required: true });
        }

      }
      else {
        if (Postcode?.value || adress2?.value || adress3?.value || city?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {

          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }

      }
    }
    if (key === 'solicitor_Details_Address_Line_2') {
      control.setErrors(null);
      const name = control.parent?.get('solicitor_Details_Name');
      const Postcode = control.parent?.get('solicitor_Details_postcode');
      const adress1 = control.parent?.get('solicitor_Details_Address_Line_1');
      const adress2 = control.parent?.get('solicitor_Details_Address_Line_2');
      const adress3 = control.parent?.get('solicitor_Details_Address_Line_3');
      const city = control.parent?.get('solicitor_Details_city');
      if (adress2?.value) {
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
      }
      else {
        if ( adress3?.value ) {
          adress2?.setErrors({ required: true });
        }
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {

          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'solicitor_Details_Address_Line_3') {
      control.setErrors(null);
      const name = control.parent?.get('solicitor_Details_Name');
      const Postcode = control.parent?.get('solicitor_Details_postcode');
      const adress1 = control.parent?.get('solicitor_Details_Address_Line_1');
      const adress2 = control.parent?.get('solicitor_Details_Address_Line_2');
      const adress3 = control.parent?.get('solicitor_Details_Address_Line_3');
      const city = control.parent?.get('solicitor_Details_city');
      if (adress3?.value) {
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!adress2?.value) {
          adress2?.setErrors({ required: true });
        }
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress2?.value && !adress3?.value && !city?.value) {

          Postcode?.setErrors(null)
          //adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'solicitor_Details_Name') {
      control.setErrors(null);
      const name = control.parent?.get('solicitor_Details_Name');
      const Postcode = control.parent?.get('solicitor_Details_postcode');
      const adress1 = control.parent?.get('solicitor_Details_Address_Line_1');
      const adress2 = control.parent?.get('solicitor_Details_Address_Line_2');
      const adress3 = control.parent?.get('solicitor_Details_Address_Line_3');
      const city = control.parent?.get('solicitor_Details_city');
      if (!control.value) {
        if (name?.value || Postcode?.value || adress1?.value || adress2?.value || city?.value) {
          control?.setErrors({ required: true })
        }
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'solicitor_Details_city') {
      control.setErrors(null);
      const name = control.parent?.get('solicitor_Details_Name');
      const Postcode = control.parent?.get('solicitor_Details_postcode');
      const adress1 = control.parent?.get('solicitor_Details_Address_Line_1');
      const adress2 = control.parent?.get('solicitor_Details_Address_Line_2');
      const adress3 = control.parent?.get('solicitor_Details_Address_Line_3');
      const city = control.parent?.get('solicitor_Details_city');
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
        //  Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'solicitor_Details_county') {
      control.setErrors(null);
      const name = control.parent?.get('solicitor_Details_Name');
      const Postcode = control.parent?.get('solicitor_Details_postcode');
      const adress1 = control.parent?.get('solicitor_Details_Address_Line_1');
      const adress2 = control.parent?.get('solicitor_Details_Address_Line_2');
      const adress3 = control.parent?.get('solicitor_Details_Address_Line_3');
      const city = control.parent?.get('solicitor_Details_city');
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
          //  Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'solicitor_Details_country') {
      control.setErrors(null);
      const name = control.parent?.get('solicitor_Details_Name');
      const Postcode = control.parent?.get('solicitor_Details_postcode');
      const adress1 = control.parent?.get('solicitor_Details_Address_Line_1');
      const adress2 = control.parent?.get('solicitor_Details_Address_Line_2');
      const adress3 = control.parent?.get('solicitor_Details_Address_Line_3');
      const city = control.parent?.get('solicitor_Details_city');
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
          //  Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'solicitor_Details_postcode') {
      control.setErrors(null);
      const name = control.parent?.get('solicitor_Details_Name');
      const Postcode = control.parent?.get('solicitor_Details_postcode');
      const adress1 = control.parent?.get('solicitor_Details_Address_Line_1');
      const adress2 = control.parent?.get('solicitor_Details_Address_Line_2');
      const adress3 = control.parent?.get('solicitor_Details_Address_Line_3');
      const city = control.parent?.get('solicitor_Details_city');
      if (!control.value) {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {

          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (adress1?.value || adress2?.value || city?.value) {
        //  Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
      }
    }

    //------------------------------------------------for auditor---------------------------------------------------------------------
    if (key === 'auditors_Details_FirmName') {
      control.setErrors(null);
      const name = control.parent?.get('auditors_Details_Name');
      const Postcode = control.parent?.get('auditors_Details_postcode');
      const adress1 = control.parent?.get('auditors_Details_Address_Line_1');
      const adress2 = control.parent?.get('auditors_Details_Address_Line_2');
      const adress3 = control.parent?.get('auditors_Details_Address_Line_3');
      const city = control.parent?.get('auditors_Details_city');
      const firmname = control.parent?.get('auditors_Details_FirmName');
      const auditedType = control.parent?.get('advisor_audited_Type');
      debugger
        if (name?.value && !control.value) {
          control.setErrors({ required: true });
        }
        if (!name?.value && !control.value) {
          control.setErrors(null);
        }
      //if (auditedType?.value === 'Senior Statutory Charity Auditor') {
      //  if (!control.value) {
      //    control.setErrors({ required: true });
      //    return; 
      //  }
      //}
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
          //  Postcode?.setErrors({ required: true });
        }

      }
      else {

        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value && !firmname?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
          firmname?.setErrors(null)
        }
      

      }
    }
    if (key === 'advisor_audited_Type') {
      control.setErrors(null);
      const name = control.parent?.get('auditors_Details_Name');
      const Postcode = control.parent?.get('auditors_Details_postcode');
      const adress1 = control.parent?.get('auditors_Details_Address_Line_1');
      const adress2 = control.parent?.get('auditors_Details_Address_Line_2');
      const adress3 = control.parent?.get('auditors_Details_Address_Line_3');
      const city = control.parent?.get('auditors_Details_city');
      const firmname = control.parent?.get('auditors_Details_FirmName');
      const advisortype = control.parent?.get('advisor_audited_Type');
      debugger
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
          //  Postcode?.setErrors({ required: true });
        }

      }
      else {

        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value && !firmname?.value && !advisortype?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
          firmname?.setErrors(null)
        }


      }
    }
    if (key === 'auditors_Details_Address_Line_1') {
      control.setErrors(null);
      const name = control.parent?.get('auditors_Details_Name');
      const Postcode = control.parent?.get('auditors_Details_postcode');
      const adress1 = control.parent?.get('auditors_Details_Address_Line_1');
      const adress2 = control.parent?.get('auditors_Details_Address_Line_2');
      const adress3 = control.parent?.get('auditors_Details_Address_Line_3');
      const city = control.parent?.get('auditors_Details_city');
      debugger
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
          //  Postcode?.setErrors({ required: true });
        }

      }
      else {
        if (Postcode?.value || adress2?.value || adress3?.value || city?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {

          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }

      }
    }
    if (key === 'auditors_Details_Address_Line_2') {
      control.setErrors(null);
      const name = control.parent?.get('auditors_Details_Name');
      const Postcode = control.parent?.get('auditors_Details_postcode');
      const adress1 = control.parent?.get('auditors_Details_Address_Line_1');
      const adress2 = control.parent?.get('auditors_Details_Address_Line_2');
      const adress3 = control.parent?.get('auditors_Details_Address_Line_3');
      const city = control.parent?.get('auditors_Details_city');
      if (adress2?.value) {
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
      }
      else {
        if ( adress3?.value ) {
          adress2?.setErrors({ required: true });
        }
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {

          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'auditors_Details_Address_Line_3') {
      control.setErrors(null);
      const name = control.parent?.get('auditors_Details_Name');
      const Postcode = control.parent?.get('auditors_Details_postcode');
      const adress1 = control.parent?.get('auditors_Details_Address_Line_1');
      const adress2 = control.parent?.get('auditors_Details_Address_Line_2');
      const adress3 = control.parent?.get('auditors_Details_Address_Line_3');
      const city = control.parent?.get('auditors_Details_city');
      if (adress3?.value) {
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!adress2?.value) {
          adress2?.setErrors({ required: true });
        }
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress2?.value && !adress3?.value && !city?.value) {

          Postcode?.setErrors(null)
          //adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'auditors_Details_Name') {
      control.setErrors(null);
      const name = control.parent?.get('auditors_Details_Name');
      const Postcode = control.parent?.get('auditors_Details_postcode');
      const adress1 = control.parent?.get('auditors_Details_Address_Line_1');
      const adress2 = control.parent?.get('auditors_Details_Address_Line_2');
      const adress3 = control.parent?.get('auditors_Details_Address_Line_3');
      const city = control.parent?.get('auditors_Details_city');
      const firmname = control.parent?.get('auditors_Details_FirmName');
      debugger
      if (name?.value && !firmname?.value) {
          firmname?.setErrors({ required: true });
      }
      if (!name?.value && !firmname?.value) {
          firmname?.setErrors(null);
      }
      if (!control.value) {
        if (firmname?.value || Postcode?.value || adress1?.value || adress2?.value || city?.value) {
          control?.setErrors({ required: true })
        }
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !city?.value && !firmname?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
          firmname?.setErrors(null)
        }
      }
    }
    if (key === 'auditors_Details_city') {
      control.setErrors(null);
      const name = control.parent?.get('auditors_Details_Name');
      const Postcode = control.parent?.get('auditors_Details_postcode');
      const adress1 = control.parent?.get('auditors_Details_Address_Line_1');
      const adress2 = control.parent?.get('auditors_Details_Address_Line_2');
      const adress3 = control.parent?.get('auditors_Details_Address_Line_3');
      const city = control.parent?.get('auditors_Details_city');
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
          //  Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'auditors_Details_county') {
      control.setErrors(null);
      const name = control.parent?.get('auditors_Details_Name');
      const Postcode = control.parent?.get('auditors_Details_postcode');
      const adress1 = control.parent?.get('auditors_Details_Address_Line_1');
      const adress2 = control.parent?.get('auditors_Details_Address_Line_2');
      const adress3 = control.parent?.get('auditors_Details_Address_Line_3');
      const city = control.parent?.get('auditors_Details_city');
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
          //  Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'auditors_Details_country') {
      control.setErrors(null);
      const name = control.parent?.get('auditors_Details_Name');
      const Postcode = control.parent?.get('auditors_Details_postcode');
      const adress1 = control.parent?.get('auditors_Details_Address_Line_1');
      const adress2 = control.parent?.get('auditors_Details_Address_Line_2');
      const adress3 = control.parent?.get('auditors_Details_Address_Line_3');
      const city = control.parent?.get('auditors_Details_city');
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
          //  Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'auditors_Details_postcode') {
      control.setErrors(null);
      const name = control.parent?.get('auditors_Details_Name');
      const Postcode = control.parent?.get('auditors_Details_postcode');
      const adress1 = control.parent?.get('auditors_Details_Address_Line_1');
      const adress2 = control.parent?.get('auditors_Details_Address_Line_2');
      const adress3 = control.parent?.get('auditors_Details_Address_Line_3');
      const city = control.parent?.get('auditors_Details_city');
      if (!control.value) {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {

          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (adress1?.value || adress2?.value || city?.value) {
          //  Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
      }
    }
    //-------------------------------------------------for examiner------------------------------------------------------------------------------------------------------------//
    if (key === 'examiners_Details_Address_Line_1') {
      control.setErrors(null);
      const name = control.parent?.get('examiners_Details_Name');
      const Postcode = control.parent?.get('examiners_Details_postcode');
      const adress1 = control.parent?.get('examiners_Details_Address_Line_1');
      const adress2 = control.parent?.get('examiners_Details_Address_Line_2');
      const adress3 = control.parent?.get('examiners_Details_Address_Line_3');
      const city = control.parent?.get('examiners_Details_city');
      debugger
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
          //  Postcode?.setErrors({ required: true });
        }

      }
      else {
        if (Postcode?.value || adress2?.value || adress3?.value || city?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {

          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }

      }
    }
    if (key === 'examiners_Details_Address_Line_2') {
      control.setErrors(null);
      const name = control.parent?.get('examiners_Details_Name');
      const Postcode = control.parent?.get('examiners_Details_postcode');
      const adress1 = control.parent?.get('examiners_Details_Address_Line_1');
      const adress2 = control.parent?.get('examiners_Details_Address_Line_2');
      const adress3 = control.parent?.get('examiners_Details_Address_Line_3');
      const city = control.parent?.get('examiners_Details_city');
      if (adress2?.value) {
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
      }
      else {
        if ( adress3?.value ) {
          adress2?.setErrors({ required: true });
        }
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {

          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'examiners_Details_Address_Line_3') {
      control.setErrors(null);
      const name = control.parent?.get('examiners_Details_Name');
      const Postcode = control.parent?.get('examiners_Details_postcode');
      const adress1 = control.parent?.get('examiners_Details_Address_Line_1');
      const adress2 = control.parent?.get('examiners_Details_Address_Line_2');
      const adress3 = control.parent?.get('examiners_Details_Address_Line_3');
      const city = control.parent?.get('examiners_Details_city');
      if (adress3?.value) {
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!adress2?.value) {
          adress2?.setErrors({ required: true });
        }
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress2?.value && !adress3?.value && !city?.value) {

          Postcode?.setErrors(null)
          //adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'examiners_Details_Name') {
      control.setErrors(null);
      const name = control.parent?.get('examiners_Details_Name');
      const Postcode = control.parent?.get('examiners_Details_postcode');
      const adress1 = control.parent?.get('examiners_Details_Address_Line_1');
      const adress2 = control.parent?.get('examiners_Details_Address_Line_2');
      const adress3 = control.parent?.get('examiners_Details_Address_Line_3');
      const city = control.parent?.get('examiners_Details_city');
      if (!control.value) {
        if (name?.value || Postcode?.value || adress1?.value || adress2?.value || city?.value) {
          control?.setErrors({ required: true })
        }
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'examiners_Details_city') {
      control.setErrors(null);
      const name = control.parent?.get('examiners_Details_Name');
      const Postcode = control.parent?.get('examiners_Details_postcode');
      const adress1 = control.parent?.get('examiners_Details_Address_Line_1');
      const adress2 = control.parent?.get('examiners_Details_Address_Line_2');
      const adress3 = control.parent?.get('examiners_Details_Address_Line_3');
      const city = control.parent?.get('examiners_Details_city');
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
          //  Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'examiners_Details_county') {
      control.setErrors(null);
      const name = control.parent?.get('examiners_Details_Name');
      const Postcode = control.parent?.get('examiners_Details_postcode');
      const adress1 = control.parent?.get('examiners_Details_Address_Line_1');
      const adress2 = control.parent?.get('examiners_Details_Address_Line_2');
      const adress3 = control.parent?.get('examiners_Details_Address_Line_3');
      const city = control.parent?.get('examiners_Details_city');
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
          //  Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'examiners_Details_country') {
      control.setErrors(null);
      const name = control.parent?.get('examiners_Details_Name');
      const Postcode = control.parent?.get('examiners_Details_postcode');
      const adress1 = control.parent?.get('examiners_Details_Address_Line_1');
      const adress2 = control.parent?.get('examiners_Details_Address_Line_2');
      const adress3 = control.parent?.get('examiners_Details_Address_Line_3');
      const city = control.parent?.get('examiners_Details_city');
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
          //  Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'examiners_Details_postcode') {
      control.setErrors(null);
      const name = control.parent?.get('examiners_Details_Name');
      const Postcode = control.parent?.get('examiners_Details_postcode');
      const adress1 = control.parent?.get('examiners_Details_Address_Line_1');
      const adress2 = control.parent?.get('examiners_Details_Address_Line_2');
      const adress3 = control.parent?.get('examiners_Details_Address_Line_3');
      const city = control.parent?.get('examiners_Details_city');
      if (!control.value) {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {

          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (adress1?.value || adress2?.value || city?.value) {
          //  Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
      }
    }
     //-------------------------------------------for Advisor common form------------------------------------------------------------------------------------------------//
    if (key === 'professionalAdvisors_Address_Line_1') {
      control.setErrors(null);
      const name = control.parent?.get('professionalAdvisors_Name');
      const Postcode = control.parent?.get('professionalAdvisors_Postcode');
      const adress1 = control.parent?.get('professionalAdvisors_Address_Line_1');
      const adress2 = control.parent?.get('professionalAdvisors_Address_Line_2');
      const adress3 = control.parent?.get('professionalAdvisors_Address_Line_3');
      const city = control.parent?.get('professionalAdvisors_City');
      debugger
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
         // Postcode?.setErrors({ required: true });
        }

      }
      else {
        if (Postcode?.value || adress2?.value || city?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
          //name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress3?.value && !adress2?.value && !city?.value) {

          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }

      }
    }
    if (key === 'professionalAdvisors_Address_Line_2') {
      control.setErrors(null);
      const name = control.parent?.get('professionalAdvisors_Name');
      const Postcode = control.parent?.get('professionalAdvisors_Postcode');
      const adress1 = control.parent?.get('professionalAdvisors_Address_Line_1');
      const adress2 = control.parent?.get('professionalAdvisors_Address_Line_2');
      const adress3 = control.parent?.get('professionalAdvisors_Address_Line_3');
      const city = control.parent?.get('professionalAdvisors_City');
      if (adress2?.value) {
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
      }
      else if (adress3?.value) {
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!adress2?.value) {
          adress2?.setErrors({ required: true });
        }
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
         // name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {

          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
      }
    }
    if (key === 'professionalAdvisors_Address_Line_3') {
      control.setErrors(null);
      const name = control.parent?.get('professionalAdvisors_Name');
      const Postcode = control.parent?.get('professionalAdvisors_Postcode');
      const adress1 = control.parent?.get('professionalAdvisors_Address_Line_1');
      const adress2 = control.parent?.get('professionalAdvisors_Address_Line_2');
      const adress3 = control.parent?.get('professionalAdvisors_Address_Line_3');
      const city = control.parent?.get('professionalAdvisors_City');
      if (adress3?.value) {
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!adress2?.value) {
          adress2?.setErrors({ required: true });
        }
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value) {
         // name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value&& !city?.value) {

          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
        }
        if (!adress2?.value && !adress3?.value) {
          adress2?.setErrors(null)
          adress3?.setErrors(null)
        }
      }
    }
    if (key === 'professionalAdvisors_Name') {
      if (!control?.value) {
        control.setErrors({ required: true });
        control.markAsTouched()
      }
      //const name = control.parent?.get('professionalAdvisors_Name');
      //const Postcode = control.parent?.get('professionalAdvisors_Postcode');
      //const adress1 = control.parent?.get('professionalAdvisors_Address_Line_1');
      //const adress2 = control.parent?.get('professionalAdvisors_Address_Line_2');
      //const city = control.parent?.get('professionalAdvisors_City');
      //const type = control.parent?.get('professionalAdvisors_Type');
      //if (!control.value) {
      //  if (name?.value || Postcode?.value || adress1?.value || adress2?.value || city?.value || type?.value) {
      //    control?.setErrors({ required: true })
      //  }
      //  if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !city?.value && !type?.value) {
      //    name?.setErrors(null)
      //    Postcode?.setErrors(null)
      //    adress1?.setErrors(null)
      //    adress2?.setErrors(null)
      //    city?.setErrors(null)
      //  }
      //}
    }
    if (key === 'professionalAdvisors_City') {
      control.setErrors(null);
      const name = control.parent?.get('professionalAdvisors_Name');
      const type = control.parent?.get('professionalAdvisors_Type');
      const Postcode = control.parent?.get('professionalAdvisors_Postcode');
      const adress1 = control.parent?.get('professionalAdvisors_Address_Line_1');
      const adress2 = control.parent?.get('professionalAdvisors_Address_Line_2');
      const adress3 = control.parent?.get('professionalAdvisors_Address_Line_3');
      const city = control.parent?.get('professionalAdvisors_City');
      const county = control.parent?.get('professionalAdvisors_County');
      const country = control.parent?.get('professionalAdvisors_Country');
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!type?.value) {
          type?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
         // Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {
        //  name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          city?.setErrors(null)
        }
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {
        //  name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !city?.value && !county?.value && !country?.value && !adress3?.value) {
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          county?.setErrors(null)
          city?.setErrors(null)
          country?.setErrors(null)
        }
      }
    }
    if (key === 'professionalAdvisors_County') {
      control.setErrors(null);
      const name = control.parent?.get('professionalAdvisors_Name');
      const Postcode = control.parent?.get('professionalAdvisors_Postcode');
      const adress1 = control.parent?.get('professionalAdvisors_Address_Line_1');
      const adress2 = control.parent?.get('professionalAdvisors_Address_Line_2');
      const adress3 = control.parent?.get('professionalAdvisors_Address_Line_3');
      const county = control.parent?.get('professionalAdvisors_County');
      const city = control.parent?.get('professionalAdvisors_City');
      const country = control.parent?.get('professionalAdvisors_Country');
      const type = control.parent?.get('professionalAdvisors_Type');
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!type?.value) {
          type?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
          // Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {
        //  name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          city?.setErrors(null)
          type?.setErrors(null);
        }
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {
       //   name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          city?.setErrors(null)
          type?.setErrors(null);
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !city?.value && !county?.value && !country?.value && !adress3?.value) {
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          county?.setErrors(null)
          city?.setErrors(null)
          country?.setErrors(null)
        }
      }
    }
    if (key === 'professionalAdvisors_Country') {
      control.setErrors(null);
      const name = control.parent?.get('professionalAdvisors_Name');
      const Postcode = control.parent?.get('professionalAdvisors_Postcode');
      const adress1 = control.parent?.get('professionalAdvisors_Address_Line_1');
      const adress2 = control.parent?.get('professionalAdvisors_Address_Line_2');
      const adress3 = control.parent?.get('professionalAdvisors_Address_Line_3');
      const city = control.parent?.get('professionalAdvisors_City');
      const county = control.parent?.get('professionalAdvisors_County');
      const country = control.parent?.get('professionalAdvisors_Country');
      const type = control.parent?.get('professionalAdvisors_Type');
      if (control.value) {
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!type?.value) {
          type?.setErrors({ required: true });
        }
        if (!Postcode?.value) {
          // Postcode?.setErrors({ required: true });
        }
      }
      else {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {
         // name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          city?.setErrors(null)
          type?.setErrors(null);
        }
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {
         // name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          city?.setErrors(null)
          type?.setErrors(null);
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !city?.value && !county?.value && !country?.value && !adress3?.value) {
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          county?.setErrors(null)
          city?.setErrors(null)
          country?.setErrors(null)
        }
      }
    }
    if (key === 'professionalAdvisors_Postcode') {
      control.setErrors(null);
      const name = control.parent?.get('professionalAdvisors_Name');
      const Postcode = control.parent?.get('professionalAdvisors_Postcode');
      const adress1 = control.parent?.get('professionalAdvisors_Address_Line_1');
      const adress2 = control.parent?.get('professionalAdvisors_Address_Line_2');
      const adress3 = control.parent?.get('professionalAdvisors_Address_Line_3');
      const city = control.parent?.get('professionalAdvisors_City');
      const county = control.parent?.get('professionalAdvisors_County');
      const country = control.parent?.get('professionalAdvisors_Country');
      if (!control.value) {
        if (!name?.value && !Postcode?.value && !adress1?.value && !adress2?.value && !city?.value) {
         // name?.setErrors(null)
          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          city?.setErrors(null)
        }
        if (!Postcode?.value && !adress1?.value && !adress2?.value && !adress3?.value && !city?.value && !county?.value && !country?.value ) {

          Postcode?.setErrors(null)
          adress1?.setErrors(null)
          adress2?.setErrors(null)
          adress3?.setErrors(null)
          city?.setErrors(null)
          county?.setErrors(null)
          country?.setErrors(null)
        }
      }
      else {
        if (!adress1?.value) {
          adress1?.setErrors({ required: true });
        }
        if (!name?.value) {
          name?.setErrors({ required: true });
        }
      }
    }
    if (key === 'professionalAdvisors_Address_Line_1' || key === 'professionalAdvisors_Address_Line_2' || key === 'professionalAdvisors_Address_Line_3'|| key === 'professionalAdvisors_Name' || key === 'professionalAdvisors_Country'|| key === 'professionalAdvisors_City' || key === 'professionalAdvisors_County' || key === 'professionalAdvisors_Postcode') {
      //control.setErrors(null);
      const name = control.parent?.get('professionalAdvisors_Name');
      const Postcode = control.parent?.get('professionalAdvisors_Postcode');
      const adress1 = control.parent?.get('professionalAdvisors_Address_Line_1');
      const adress2 = control.parent?.get('professionalAdvisors_Address_Line_2');
      const city = control.parent?.get('professionalAdvisors_City');
      const Type = control.parent?.get('professionalAdvisors_Type');
      if (Postcode?.value || adress2?.value || city?.value || name?.value || adress1?.value) {
        if (!Type?.value)
        Type?.setErrors({ required: true });
      }
    }
    //if (key === 'professionalAdvisors_Type') {
    //  debugger
    //  control.setErrors(null);
    //  const name = control.parent?.get('professionalAdvisors_Name');
    //  const Type = control.parent?.get('professionalAdvisors_Type');
    //  if (Type?.value) {
    //    if (!name?.value) {
    //      name?.setErrors({ required: true });
    //    }
    //  }
    //}
   // --------------------------------------------------------------for trustee form--------------------------------------------------------------------------
    if (key === 'name') {
      debugger
      if (!control.value)
      control.setErrors({required:true});
    }

    //if (key === 'date_of_appointment') {
    //  debugger
    //  if (!control.value)
    //  control.setErrors({ required: true });
    //}
    if (key === 'reporting_status') {
      control.setErrors(null);
      debugger
      if (!control.value)
      control.setErrors({ required: true });
    }
    if (key === 'reg_charity_number') {
      debugger
      if (!control.value)
      control.setErrors({ required: true });
    }
    if (key === 'charity_name') {
      debugger
      if (!control.value)
      control.setErrors({ required: true });
    }

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
